import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { CarOptionStyledAC } from './AC/CarOptionStyled.AC';
import { CarOptionStyledAP } from './AP/CarOptionStyled.AP';
import { CarOptionStyledDS } from './DS/CarOptionStyled.DS';
import { CarOptionStyledOV } from './OV/CarOptionStyled.OV';
import { CarOptionStyledOV as CarOptionStyledOVGB } from './OV/GB/CarOptionStyled.OV';
import { CarOptionStyled } from './CarOptionStyled';
import { SC } from '../../../styles/theme';
import { IConfiguratorOption } from 'src/redux/configurator/configurator.duck.interface';

export type CarOptionProps = SC & {
    option: IConfiguratorOption;
    onChange: (o: IConfiguratorOption) => void;
    onClick?: (param: any) => void;
    sendFullOptionAsParameterOnClick?: boolean;
    isOpen?: boolean;
    index?: number | string;
};

const CarOption = (props: CarOptionProps) => {
    if (BRAND === 'OV') return isMarketGB ? <CarOptionStyledOVGB {...props} /> : <CarOptionStyledOV {...props} />;
    if (BRAND === 'AC') return <CarOptionStyledAC {...props} />;
    if (BRAND === 'AP') return <CarOptionStyledAP {...props} />;
    if (BRAND === 'DS') return <CarOptionStyledDS {...props} />;
    return <CarOptionStyled {...props} />;
};

export default CarOption;
